import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getOrganisationDataWithId, updateOrganisationWithId } from "../../utils/api/organisationAPI";

const initialState = {
    orgData: null,
    loading: false,
    error: null,
};

export const fetchOrgDataWithId = createAsyncThunk(
    "organization/fetchOrgDataWithId",
    async (orgId, { rejectWithValue }) => {
        try {
            const response = await getOrganisationDataWithId(orgId);
            
            // Assuming API returns { data: {...} }
            if (!response) {
                return rejectWithValue("Invalid response structure");
            }

            return response; 
        } catch (e) {
            console.error("Error fetching organization data:", e);
            return rejectWithValue(e.message || "Failed to fetch organization data");
        }
    }
);
export const updateOrgDataWithId = createAsyncThunk(
    "organization/updateOrgDataWithId",
    async ( {id, orgData}, { rejectWithValue }) => {
      try {
        const response = await updateOrganisationWithId(id, orgData);
        if (!response) {
          return rejectWithValue("Invalid response structure");
        }
        return response;
      } catch (e) {
        console.error("Error updating organization data:", e);
        return rejectWithValue(e.message || "Failed to update organization data");
      }
    }
  );

const orgSlice = createSlice({
    name: "orgDetail",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchOrgDataWithId.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOrgDataWithId.fulfilled, (state, action) => {
                state.loading = false;
                state.orgData = action.payload || null;
            })
            .addCase(fetchOrgDataWithId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Something went wrong";
            })
            .addCase(updateOrgDataWithId.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateOrgDataWithId.fulfilled, (state, action) => {
                state.loading = false;
                state.orgData = action.payload || null;
            })
            .addCase(updateOrgDataWithId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Something went wrong";
            });
    }
});

export default orgSlice.reducer;
